import { getGeneratedFeatureSwitchVariants } from "@web-monorepo/feature-switches/getGeneratedFeatureSwitchVariants";

export const BOOLEAN_OPTIONS = ["on", "off"];
export const MULTIVARIATE_OPTIONS = ["control", "test"];

export function getFallbackPredefinedValuesForSwitch(value: string): string[] {
  if (value === "on") {
    return [...BOOLEAN_OPTIONS];
  }
  if (value === "off") {
    // "off" could be either type of switch, so we include both
    return [...BOOLEAN_OPTIONS, ...MULTIVARIATE_OPTIONS];
  }
  // otherwise, use the multivariate options (getting unique values)
  return [...new Set([value, ...MULTIVARIATE_OPTIONS])];
}

export function getPredefinedValuesForSwitch(
  switchName: string,
  value: string,
  getVariants = getGeneratedFeatureSwitchVariants,
): string[] {
  const generatedVariants = getVariants(switchName);
  if (!generatedVariants) {
    return getFallbackPredefinedValuesForSwitch(value);
  }

  return generatedVariants.includes(value) ? generatedVariants : [...new Set([value, ...generatedVariants])];
}
